import { render, staticRenderFns } from "./TyC.vue?vue&type=template&id=17aabb73&scoped=true&"
import script from "./TyC.vue?vue&type=script&lang=js&"
export * from "./TyC.vue?vue&type=script&lang=js&"
import style0 from "./TyC.vue?vue&type=style&index=0&id=17aabb73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aabb73",
  null
  
)

export default component.exports